import { IS_WEBOS } from './is-webos';

const closeTvApp = (): void => {
  if (window.tizen && window.tizen.application) {
    const app = window.tizen.application.getCurrentApplication();
    app.exit();
  } else if (IS_WEBOS) {
    window.close();
  }
};

export default closeTvApp;
